import { faBan } from "@fortawesome/pro-regular-svg-icons";
import React from "react";
import { useTranslation } from "react-i18next";

import type { ExternalPageTypeEnum } from "generated/graphqlExternal";
import { formatDateWithTime } from "utils/formatDate";

import { apiTranslate } from "@/translations/i18n";
import ExternalStateMessage from "./ExternalStateMessage";

interface IInviteExpiredProps {
  closesAt?: string | null;
  inviteType: ExternalPageTypeEnum;
}

const InviteExpired: React.FC<IInviteExpiredProps> = ({ closesAt, inviteType }) => {
  const { t } = useTranslation();

  return (
    <ExternalStateMessage
      icon={faBan}
      headerTitle={apiTranslate(`enums.external_page_type_enum.${inviteType}`)}
      title={t("external_invite.expired.title")}
      description={t("external_invite.expired.description", { date: formatDateWithTime(closesAt) })}
      tip={t("external_invite.expired.tip")}
      dataCy="externalInviteExpired"
    />
  );
};

export default InviteExpired;
